import { Component, OnInit, Input, forwardRef, SimpleChanges } from '@angular/core';
import { 
    IonSpinner, ToastController
} from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { MarvMessageComponent } from '@marv/components';
import { MissionAdditionalDataComponent } from '@app/components';
import { OperationService, StoreService } from '@app/services';
import { OperationCard } from '@app/models';

@Component({
    selector: 'app-store-details-additional-data',
    templateUrl: './additional-data.component.html',
    styleUrls: ['./additional-data.component.scss'],
    imports: [IonSpinner, TranslatePipe, forwardRef(() => MarvMessageComponent), forwardRef(() => MissionAdditionalDataComponent)]
})
export class StoreDetailsAdditionalDataComponent  implements OnInit {

    @Input({alias : 'storeId', required : true}) storeId: number;

    isFetching: boolean = false;
    opCocaVitrine: OperationCard|null = null;
    additionalsDatas: any = null;
    
    constructor(
        private toastController: ToastController,
        public translateService: TranslateService,
        private storeService: StoreService
    ) { }

    async ngOnInit() {
        // A MODIFIER - Ajout de la saisie des vitrines en dur
        this.opCocaVitrine = OperationService.Operations.find(o => o.id === 2028) || null;           
        await this.loadAdditionalsDatas();        
    }
    
    async loadAdditionalsDatas() {
        this.isFetching = true;
        if(this.opCocaVitrine !== null){
            this.additionalsDatas = await this.storeService.loadAdditionalsDatas(this.opCocaVitrine.id, this.storeId); 
        }
        this.isFetching = false;
    }
    
    async onChangeAdditionalsDatas(data: any){
        if(this.opCocaVitrine && data !== null){
            let statutSave = await this.storeService.saveAdditionalsDatas(this.opCocaVitrine.id, this.storeId, data);
            if(statutSave){
                await this.loadAdditionalsDatas();
                const toast = await this.toastController.create({
                    message: this.translateService.instant('MSG_SUCCESS_SAVE_ADDITIONALS_DATAS'),
                    duration: 6000,
                    position: 'top',
                    color: 'success'
                });
                await toast.present();
            }
            else{
                const toast = await this.toastController.create({
                    message: this.translateService.instant('MSG_ERROR_SAVE_ADDITIONALS_DATAS'),
                    duration: 6000,
                    position: 'top',
                    color: 'danger'
                });
                await toast.present();
            }
        }
    }
}
